// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"882f5d93","591":"55555176"}[chunkId] + ".chunk.js";
};